import instantsearch from 'instantsearch.js/es'
import algoliasearch from 'algoliasearch/lite'
import scrollManager from '../utils/scrollManager'

import { searchBox, configure } from 'instantsearch.js/es/widgets'
import customHitsPanel from '../utils/algolia/customHitsPanel'

export default {
  name: 'search-panel',

  ui: {
    searchbox: '[js-search-panel-searchbox]',
    panel: '[js-search-panel-panel]',
    results: '[js-search-panel-results]',
    originInput: '[js-search-panel-origin-input]',
    close: '[js-search-panel-close]',
  },

  events: [
    {
      target: 'originInput',
      on: 'focus',
      handle () {
        this.search.start()
        this.el.querySelector('.ais-SearchBox-input').focus()
        this.ui.originInput.remove()
      },
    },
    {
      target: 'close',
      on: 'click',
      handle () {
        scrollManager.restart()
        this.ui.panel.classList.add('is-hidden')
      },
    },
  ],

  componentDidMount () {
    const indexName = `${config.algolia.env}_pages`

    this.searchClient = algoliasearch(
      config.algolia.applicationID,
      config.algolia.apiKey,
    )

    this.search = instantsearch({
      indexName: `${indexName}`,
      searchClient: this.searchClient,
    })

    const panel = this.ui.panel
    let timerId

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: 1000,
        facetFilters: [
          `locale:${config.locale}`,
          'visible:true',
        ],
      }),
      searchBox({
        container: this.ui.searchbox,
        placeholder: 'Rechercher un document, une actualité…',
        showSubmit: false,
        showReset: false,
        queryHook (query, search) {
          if (query.length > 0) {
            clearTimeout(timerId)
            timerId = setTimeout(() => search(query), 200)
            panel.classList.remove('is-hidden')
            scrollManager.stop()
          } else {
            panel.classList.add('is-hidden')
            scrollManager.restart()
          }
        },
      }),
      customHitsPanel({
        container: this.ui.results,
        searchInstance: this.search,
      }),
    ])
  },
}
